<template>
<v-container grid-list-md>
    <v-row justify="center">

        <v-dialog v-model="dialogFirstinfo" persistent max-width="500">
            <v-card>
                <v-card-title class="modal-titulo">
                    Información
                </v-card-title>

                <v-card-text>
                <template>
                    <!-- <v-row justify="space-around">
                    <v-icon @click="model--">
                        mdi-minus
                    </v-icon>
                    {{ model+1 }}
                    <v-icon @click="model++">
                        mdi-plus
                    </v-icon>
                    </v-row> -->
                <v-carousel v-model="model" 
                    hide-delimiters 
                    :continuous="false" 
                    :show-arrows="bandera"
                    style="height:350px;" >
                    <v-carousel-item
                        v-for="(item,i) in items"
                        :key="i"
                        :src="item.src"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                        style="object-fit: fill !important;"
                    >
                    </v-carousel-item>
                </v-carousel>    
                </template>
                </v-card-text>

                <v-card-text class="modal-normal">
                    Para tener una mejor experiencia de navegación en el mapa es necesario que permitas acceder a tu ubicación.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
               
                     <v-btn class="modal-btn-cerrar" text @click="cerrar">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</v-container>
</template>

<script>
// @ is an alias to /src
import desktop1 from '../assets/tutorial/desktop1.png';
import desktop2 from '../assets/tutorial/desktop2.png';
import desktop3 from '../assets/tutorial/desktop3.png';
import movil1 from '../assets/tutorial/movil1.jpg';
import movil2 from '../assets/tutorial/movil2.jpg';
import movil3 from '../assets/tutorial/movil3.jpg';
import movil4 from '../assets/tutorial/movil4.jpg';
import movil5 from '../assets/tutorial/movil5.jpg';

import {
    mapGetters,
    mapMutations
} from "vuex";

export default {
    name: 'loadinginfo',
    components: {

    },
    data() {
        return {
            model: 0,
            bandera:false,
            items: [],
            destop: [
                {
                    src: desktop1,
                },
                {
                    src: desktop2,
                },
                {
                    src: desktop3,
                },
            ],
            movil: [
                {
                    src: movil1,
                },
                {
                    src: movil2,
                },
                {
                    src: movil3,
                },
                {
                    src: movil4,
                },
                {
                    src: movil5,
                },
            ],
        }
    },
    computed: {
        ...mapGetters(["dialogFirstinfo"]),
    },
    methods: {

        cerrar(){
        this.setdialoginfo(false);
        },
        tutorial(){
        this.setdialoginfo(false);
        },

        ...mapMutations(['setdialoginfo'])

    },
    created() {
        if (screen.width < 900){
           this.items=this.movil;
           this.bandera=true;
        }else{
            this.items=this.destop;
            this.bandera=true;
        }
    }
}
</script>

<style>
@font-face {
    font-family: 'BgFont';
    src: url('../assets/fonts/NunitoSans-Regular.ttf') format('truetype');
}

.modal-titulo {
    font-family: BgFont !important;
    font-style: normal;
    font-weight: bold !important;
    font-size: 21px !important;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.modal-normal {
    font-family: BgFont !important;
    font-style: normal;
    font-weight: normal ;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #012244 !important;
}

.modal-btn-cerrar {
    font-family: BgFont !important;
    font-size: 16px !important;
    color: #bc157c !important;
    caret-color: #bc157c !important;
}

.v-image__image {
    z-index: -1 !important;
    width: 100% !important;
    height: 350px !important;
    background-size: contain !important;
}
</style>